var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnHeizoel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.45 56.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#4b4a4a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.85 40.36c0-7 10.81-25.17 14.08-30.51a1.09 1.09 0 0 1 1.85 0c3.28 5.34 14.08 23.48 14.08 30.51a15 15 0 0 1-30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24 44.6a9.81 9.81 0 0 1-8.51 4.91M30.66 15.26c0-3.27 5-11.69 6.54-14.17a.51.51 0 0 1 .86 0C39.58 3.57 44.6 12 44.6 15.26a7 7 0 0 1-13.94 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnHeizoel);
export default __webpack_public_path__ + "static/media/icn-heizoel.d37b9fca58935e7fbc7c6a0f6823e9b1.svg";
export { ForwardRef as ReactComponent };